import React from "react";
import './Show.css'

const Show = ({ setCountShow }) => {
  return (
    <div className="show-block">
      <div className="show-block__text">Show</div>
      <select className="show-block__select">
        <option value={10} label="10"></option>
        <option value={25} label="25"></option>
        <option value={50} label="50"></option>
        <option value={100} label="100"></option>
      </select>
      <div className="show-block__text">entries</div>
    </div>
  );
};

export default Show;
